export const environment = {
  production: true,
    baseUrl: "https://mifugo360.emtechhouse.co.ke",
  API: "https://mifugo360.emtechhouse.co.ke"


};
